import { Component, Input, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { UploadSession } from '../../../core/models/upload-session.model';
import { CloudUploadService } from '../../../core/services/cloud-upload.service';

@Component({
  selector: 'black-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css'],
  standalone: false,
})
export class FileUploadComponent {
  private uploadService = inject(CloudUploadService);

  @Input()
  progressType: 'linear' | 'radial' = 'linear';

  @Input()
  uploadSession: UploadSession | null = null;

  uploadComplete: Subject<boolean> = new Subject();

  // convert to kilo, mega, giga, tera bytes
  getFileSize(sizeInBytes: number): string {
    if (sizeInBytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
    return (
      parseFloat((sizeInBytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    );
  }

  // called when upload is paused
  handleUploadPause(uploadId: number) {
    this.uploadService.pauseUpload(uploadId);
  }

  handleUploadResume(uploadId: number) {
    this.uploadService.resumeUpload(uploadId);
  }

  handleUploadCancel(uploadId: number) {
    this.uploadService.cancelUpload(uploadId);
  }

  handleUploadRetry(uploadId: number) {
    this.uploadService.retryUpload(uploadId);
  }

  // utils
  formatName(name: string): string {
    if (name.length > 20) {
      return `${name.slice(0, 7)}...${name.slice(-7)}`;
    }
    return name;
  }

  getProgressBarColor() {
    const prefix = this.progressType === 'radial' ? 'text-' : 'daisy-progress-';

    if (this.uploadSession?.uploadStatus === 'completed') {
      return prefix + 'success';
    } else if (this.uploadSession?.uploadStatus === 'failed') {
      return prefix + 'error';
    } else if (this.uploadSession?.uploadStatus === 'uploading') {
      return prefix + 'primary';
    } else if (this.uploadSession?.uploadStatus === 'cancelled') {
      return prefix + 'warning';
    }
    return prefix + 'secondary';
  }
}
